import {Configuration as config, StudySession, Logger} from '@camcog/speech-client';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {unregister} from './registerServiceWorker';
import {VoiceUI} from '@camcog/speech-ui';

ReactDOM.render(
    <VoiceUI webWorkerPath="speech_worker.js"
             apiBaseUrl={config.API_BASE_URL}
             socketUrl={config.SOCKET_URL}
             stimuliBaseUrl={config.STIMULI_BASE_URL}
             ttsBaseUrl={config.TTS_ENDPOINT}
             onSessionEnd={(session: StudySession) => {
                 Logger.log('Session ended: ' + JSON.stringify(session))
                 const sessionParams = session.parameters
                 if (sessionParams?.endOfSessionPath) { //TO load dashboards etc
                     const  {id,
                         studyId, participantId, sessionNumber} = session;
                     const queryParameters = `?sessionId=${id}&studyId=${studyId}&participantId=${participantId}&sessionNumber=${sessionNumber}`;
                     const site = window.location.origin;
                     const path = sessionParams.endOfSessionPath;
                     const completeUrl = site + path + queryParameters;
                     Logger.log(`loading end of session page ${completeUrl}`);
                     document.location.href = completeUrl
                 }
             }}
             onSessionError={(error: Error, sessionId: string) => {
                 Logger.log('Voice diary caught error: ' + error + 'in session: ' + sessionId);
             }}/>
    ,
    document.getElementById('voice-ui') as HTMLElement
);
unregister();





// WEBPACK FOOTER //
// ./src/index.tsx